// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__iby3_","label":"SetPasswdForm_label__o4tf2"};